import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, CheckRoundOutlineIcon, Text } from '@common-fe/common-fe';

import ROUTES from '@/common/routes';
import { useBreadcrumbs } from '@/modules/core/hooks';
import { ElectronicAgreementMessage } from '@/modules/transaction/components/Statements/components/ElectronicAgreementMessage';
import { useMyEnrollments, useOrganizationProperties } from '@/modules/transaction/hooks';
import useEmployeeStore from '@/modules/user/stores/useEmployee.store';

import { HEADERS, StatementsList } from './components/StatementsList';

interface Props {
  accountId: string;
}

const Statements: React.FC<Props> = ({ accountId }) => {
  const { t } = useTranslation();
  const { organizationProperties } = useOrganizationProperties();
  const { currentMyAccount } = useMyEnrollments(accountId);

  useBreadcrumbs([{
    key: ROUTES.HOME,
    title: t('Home'),
    value: ROUTES.HOME,
  },
  {
    key: ROUTES.MY_ACCOUNTS,
    title: t('My accounts'),
    value: `${ROUTES.MY_ACCOUNTS}`,
  },
  {
    key: ROUTES.MY_ACCOUNTS_DETAILS(accountId),
    title: currentMyAccount?.name,
    value: ROUTES.MY_ACCOUNTS_DETAILS(accountId),
  },
  {
    key: ROUTES.STATEMENTS(accountId),
    title: t('Statements'),
    value: ROUTES.STATEMENTS(accountId),
  }], true);
  const { employee } = useEmployeeStore();

  return (
    <Box data-testId="statements">
      <Box direction="row" align="center">
        <Text size="3xl" weight="bold">{t('Statements')}</Text>
        {employee?.isElectronicStatementOnly ? (
          <Box margin={{ left: 'spacing12' }} direction="row" align="center">
            <CheckRoundOutlineIcon color="success" size="24px" />
            <Text color="success" size="large">You've opted-in to paperless statements</Text>
          </Box>
        ) : null}
      </Box>
      <ElectronicAgreementMessage margin={{ top: 'spacing24' }} />
      <StatementsList accountId={accountId} headers={HEADERS} isStandaloneMode />
      <Box margin={{ top: 'spacing24' }}>
        <Text color="textSecondary">
          {t('For any questions, please contact us at ')}{organizationProperties?.customerServiceEmail}
        </Text>
      </Box>
    </Box>
  );
};

export default Statements;
